
export function msDetectionEventMap(event, cameras_proxy) {
    try {

        let media = '';
        let media_plate = '';
        let camera = cameras_proxy.find(src => src.id == event.cameraID);

        // Verificamos que event.images sea un array y que contenga al menos un elemento
        if (Array.isArray(event.images) && event.images.length > 0) {

            if (event.images.length >= 2) {
                // Si tiene al menos dos imágenes
                media = event.images[0];
                media_plate = event.images[1];
            }
            else if (event.images.length === 1) {
                // Si solo tiene una imagen asignar la primera imagen a la varia media
                media = event.images[0];
            }
        }

        return {
            ...event,
            ...camera,
            id: event.eventId,
            data: event.metadata,
            event_type: event.eventType,
            formatted_event_type: event.eventType,
            camera_proxy: { camera: { name: camera ? camera.camera.name : event.cameraID } },
            media: { url: media },
            media_plate: { url: media_plate },
            created_at: event.createdAt,
            metadata: [{ data: event.metadata[0].data }],
            event_created_at: event.eventCreatedAt,
        };

    } catch (error) {
        console.error(error);
        return null;
    }
}